<template>
  <ValidationObserver ref="form">
    <FormToolbar
      title="Start Voyage"
      :onSubmitClick="submit"
      :isSubmitting="isSubmitting"
      :onCloseClick="onCloseClick"
      :showDeleteButton="false"
    />
    <v-form class="mt-1">
      <v-container>
        <v-row>
          <v-col cols="8" md="4" class="py-0 ma-0">
            <v-dialog
              ref="startDateMenu"
              v-model="startDateMenu"
              transition="scale-transition"
              width="unset"
            >
              <template v-slot:activator="{ on }">
                <ValidationProvider
                  name="Start Date"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    v-model="report.startDate"
                    label="Start Date"
                    :error-messages="errors"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </ValidationProvider>
              </template>
              <v-date-picker
                v-model="report.startDate"
                @change="startDateSelected"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="startDateMenu = false"
                  >Cancel</v-btn
                >
              </v-date-picker>
            </v-dialog>
          </v-col>
          <v-col cols="4" md="2" class="py-0 ma-0">
            <v-dialog
              ref="startTimeMenu"
              v-model="startTimeMenu"
              transition="scale-transition"
              max-width="300px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="time"
                  v-model="report.startTime"
                  label="Start Time"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-time-picker
                v-if="startTimeMenu"
                v-model="report.startTime"
                format="24hr"
                full-width
                @click:minute="startTimeMenu = false"
              ></v-time-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <p class="text-caption text-start">{{ dateTimeMessage }}</p>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </ValidationObserver>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FormToolbar from '../ui/FormToolbar.vue';
import dateTimeHelpers from '../../mixins/DateTimeHelpers';
import '../../validators';


export default {
  name: 'StartVoyageForm',
  components: {
    ValidationProvider,
    ValidationObserver,
    FormToolbar,
  },
  props: {
    report: Object,
    onSubmitClick: Function,
    onCloseClick: Function,
    onDeleteClick: Function,
    isSubmitting: Boolean,
  },
  data() {
    return {
      startDateMenu: false,
      startTimeMenu: false,
      dateTimeMessage: 'Previous voyage end time for vessel not found',
    };
  },
  methods: {
    submit() {
      this.$refs.form.validate()
        .then((isValid) => {
          if (isValid) {
            this.report.status = 'InProgress';
            this.setReportDateTimeValue();
            this.onSubmitClick();
          }
        });
    },
    setReportDateTimeValue() {
      const { startDate, startTime } = this.report;
      this.report.voyageStartDateTimeLt = dateTimeHelpers
        .dateAndTimeLtString(startDate, startTime);
    },
    setDefaultStartDateAndTimeValues() {
      // Default to previous voyage end time or current time
      const previousVoyageEndTime = this.report.previousVoyageEndTimeForVessel;
      if (previousVoyageEndTime) {
        this.report.startDate = dateTimeHelpers.getDateStringFromDateTime(previousVoyageEndTime);
        this.report.startTime = dateTimeHelpers.getTimeStringFromDateTime(previousVoyageEndTime);

        const dateTimeEnded = this.$options
          .filters.removeTAndSecondsAndFormatDate(previousVoyageEndTime);

        this.dateTimeMessage = `Previous voyage for vessel ended ${dateTimeEnded}`;
      } else {
        this.report.startDate = dateTimeHelpers.getCurrentDateLt();
        this.report.startTime = dateTimeHelpers.getCurrentTimeLt();
      }
    },
    startDateSelected() {
      this.startDateMenu = false;
      this.startTimeMenu = true;
    },
  },
  created() {
    this.setDefaultStartDateAndTimeValues();
  },
};
</script>
